<template>
    <div>
        <!-- Table Container Card -->
        <template>
          <div id="breadcrumb-alignment" class="mb-1">
            <div class="d-flex justify-content-start breadcrumb-wrapper">
              <b-breadcrumb
                :items="breadCrumb()"
              />
            </div>
          </div>
        </template>
        <b-card no-body>
            <b-card-body>
                <b-row class="mb2_last_child">

                    <b-col cols="12" md="4" class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five ">
                        <v-select
                            v-model="siteData"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="site_name"
                            :options="sites"
                            placeholder="Project Site"
                            :clearable="false"
                            @input="siteUpdate(); setFilter();"
                        >
                            <template #selected-option="{ site_name }">
                            <span v-if="site_name.length < 23">{{site_name}}</span>
                            <span v-if="site_name.length >= 23">{{site_name.substring(0, 23) + '...'}}</span>
                            </template>
                        </v-select>
                    </b-col>

                    <b-col cols="12" md="4" class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five ">
                        <v-select
                            v-model="building"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="name"
                            :options="buildings"
                            placeholder="Select Building"
                            @input="buildingUpdate(); setFilter();"
                            :clearable="true"
                        >
                            <template #selected-option="{ name }">
                            <span v-if="name.length < 23">{{name}}</span>
                            <span v-if="name.length >= 23">{{name.substring(0, 23) + '...'}}</span>
                            </template>
                        </v-select>
                    </b-col>

                    <b-col cols="12" md="4" class="float-right mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five ">
                        <b-button title="Refresh" variant="primary" @click="fetchLatest();">
                            <feather-icon icon="RefreshCwIcon" size="16" class="align-middle text-body"/>
                        </b-button>
                    </b-col>

                    <!-- <b-col cols="12" md="4" class="mb-md-0 mb-2">
                        <v-select
                            v-model="level"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="levels"
                            placeholder="Select"
                            @input="getDataList()"
                        >
                        </v-select>
                    </b-col> -->

                </b-row>
            </b-card-body>
        </b-card>

        <div v-if="levels.length > 0 && siteData && building">
            <b-card :title="l" class="mb-2" v-for="(l,i) in levels" :key="i+''+building._id">
                <b-row>
                    <!-- <b-col md="6">
                        <overViewTable title="Male" :level="l" :building="building" />
                    </b-col>

                    <b-col md="6">
                        <overViewTable title="Female" :level="l" :building="building" />
                    </b-col> -->

                    <b-col md="6" v-for="(location, index) in locations">
                        <overViewTable :location="location._id" :title="location.name" :level="l" :building="building" />
                    </b-col>
                </b-row>
            </b-card>
        </div>

        <div v-else-if="!siteData || !building">
            <div v-for="site in siteData ? [siteData] : sites " :key="site._id">
                <OverViewTableWithoutSite :site="site._id" :site_name="site.site_name" />
            </div>
        </div>

        <div v-else>
            No Level Found 
        </div>
    
    </div>
</template>

<script>
import {
    BFormSelect, BFormSelectOption, BCardBody, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BAlert, BFormText, BFormGroup, BForm,BBreadcrumb
} from 'bootstrap-vue'
import { POST_API } from "../../../store/actions.type"
import vSelect from 'vue-select';
import overViewTable from './OverviewTable';
import OverViewTableWithoutSite from './OverViewTableWithoutSite';
import Bus from "../../../event-bus";

export default {
    components: {
        vSelect, BFormSelect, BFormSelectOption, BCardBody, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, BFormCheckbox, BAlert, BFormText, BFormGroup, BForm,overViewTable, OverViewTableWithoutSite,BBreadcrumb
    },

    data() {
        return {
            webUrl: process.env.VUE_APP_SERVER_URL,
            error_message: null, 
            showDismissibleAlert:false,
            sites: [],
            siteData: null,
            buildings: [],
            building:null,
            levels: [],
            level:'',
            items:[],

            refreshTime: null,

            locations : null,

            // vars for filter fetch
                filter: {},
                prev_route: null,
        }
    },

    methods : {
        allLocations(){
            return this.$store.dispatch(POST_API, {
                data:{},
                api: '/api/all-database-location-2'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0,0);
                } else {
                    this.locations = this.$store.getters.getResults.data;
                    return this.locations;
                }
            });
        },

        allSites(){
            return this.$store.dispatch(POST_API, {
                data:{
                    role:this.$store.getters.currentUser.role,
                    om_sites:this.$store.getters.currentUser.om_sites,
                },
                api: '/api/all-sites'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0,0);
                } else {
                    this.sites = this.$store.getters.getResults.data;
                    // if (this.sites.length == 1 ) {
                    //     this.siteData = this.sites[0];
                    //     this.siteUpdate();
                    // }
                    /*var obj = {
                        _id:'all-site',
                        site_name:'All Project Sites'
                    }
                    this.sites.unshift(obj);*/

                    this.siteData = this.defaultSite(this.sites);
                    this.filterState();
                    this.siteUpdate();
                    
                    return this.sites;
                }
            });
        },
        siteUpdate(){
            
            this.getBuilding();
            //this.getDataList();
        },
        buildingUpdate() {
            this.getLevels();
            //this.getDataList();
        },
        

        getBuilding(){
            
            this.buildings = [];
            this.building = null;
            this.levels = [];
            this.level = '';

            return this.$store.dispatch(POST_API, {
                data:{
                    role:this.$store.getters.currentUser.role,
                    site:this.siteData ? this.siteData._id : null
                },
                // api: '/api/all-buildings'
                api: '/api/all-buildings-with-level'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                } else {
                    this.buildings    = this.$store.getters.getResults.data;
                    return this.buildings;
                }
            });
        },

        getLevels(){
            this.levels = [];
            this.level = '';

            this.levels = this.building ? this.building.floor : [];

            return this.levels;
        },

        setFilter(){
            // save filters in local store 
            if(this.siteData != ''){
                this.filter['site'] = this.siteData;
            }
            if(this.building != ''){
                this.filter['building'] = this.building;
            }

            localStorage.setItem("filter_report", JSON.stringify(this.filter));
        },

        fetchLatest(){
            if(this.siteData && this.building){
                this.getBuilding().then(()=>{
                    this.filterState();
                })
                // console.log('refresh from if')
            }
            else if(!this.siteData || !this.building){
                Bus.$emit('update-overview');
                this.filterState();
                // console.log('refresh from else if')
            }
        },
        breadCrumb(){
          var item = [{
            to:{name:'client-dashboard'},
            text: 'Dashboard',
          },{
            to:null,
            text: 'Smart Sensors',
          },{
            to:null,
            text:'Device Reports'
          }];
          return item;
        },

        refreshData(){
            if(this.$route.name == 'device-report'){
                this.refreshTime = setInterval(() => {
                    // console.log(new Date().toLocaleTimeString());
                    // this.fetchLatest()
                    // this.filterState();
                    Bus.$emit('update-sensor-report');
                // }, 350000)
                }, 10000)
            }
        }, 

        filterState(){
            var filter = JSON.parse(localStorage.getItem("filter_report"));

            if(filter || this.prev_route && (this.prev_route.name == 'device-stats' || this.prev_route.name == 'sensor-stats' || this.prev_route.name == 'device-report')){

                if(this.prev_route && this.prev_route.name != 'smart-toilet' && filter){
                    this.siteData = filter.site ? filter.site : null;
                    this.getBuilding('filter').then(() => {
                        this.building = filter.building ? filter.building : null;
                        this.getLevels('filter');
                        this.level = filter.level ? filter.level : '';
                    })
                } else {
                    localStorage.setItem("filter_report", JSON.stringify({}));
                }
            } else {
                localStorage.setItem("filter_report", JSON.stringify({}));
            }
        },

        getSensorRecords(){
            return this.$store.dispatch(POST_API, {
                data:{
                    role:this.$store.getters.currentUser.role,
                    site:this.siteData ? this.siteData._id : null
                },
                api: '/api/device-report'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                } else {
                    this.buildings    = this.$store.getters.getResults.data;
                    return this.buildings;
                }
            });
        }

    },
    mounted(){
        // updating overview data automatically 
        this.refreshData();

        this.allSites().then(() => {
            this.getSensorRecords();
        });

        this.filterState();

        this.allLocations();
    },

    beforeDestroy () {
        clearInterval(this.refreshTime)
    },
    
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prev_route = from;
        });
    }
}
</script>

<style lang="scss" scoped>
    .per-page-selector {
        width: 90px;
    }
</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
